import { environment } from "../../environment";
import axios from "axios";


export const CurriculaService = () => {

    const getCurriculaById = async (entityId: string) => {
        try {
            const path = environment.contentUrl + "curricula/curriculaById/" + entityId;
            return await axios.get(path);
        } catch (err) {
            throw err;
        }
    };
    const getCurriculaByIdNew = async (entityId: string) => {
        try {
            const path = environment.contentUrl + "curricula/curriculaByIdNew/" + entityId;
            return await axios.get(path);
        } catch (err) {
            throw err;
        }
    };


    const getShiHrFolders = async () => {
        try {
            const path = environment.contentUrl + "curricula/getShiHrFolders";
            return await axios.get(path);
        } catch (err) {
            throw err;
        }
    };


    return {
        getCurriculaById,
        getCurriculaByIdNew,
        getShiHrFolders
    }
}